import Detail from '@/components/Service/DetailService';

export async function getServerSideProps(context) {

    try {

        const res = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/service/get-detail/${context.params.sort_url}`, {
            headers: {
                'Content-Type': 'application/json',
                locale: context.locale

            }
        });
        const data = await res.json();
        const data_value = data.data.find(it => it.language.sign === context.locale);
        if (!data || data.code !== 200) {
            return {
                notFound: true,
            };
        }
        return {
            props: data_value, // will be passed to the page component as props
        };
    } catch (error) {
        console.log(error);
        return {
            notFound: true,
        };
    }

}

export default Detail;